import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: Index,
    children: [
      {
        path: '/',
        name: 'Home',
        meta: {
          title: '中车低碳社区可视化数据'
        },
        component: () => import(/* webpackChunkName: "Home" */ '../views/Home/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
});
export default router
